<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">
        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}
    </div>

    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">
        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}
    </div>

    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">
        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">E-Service Management</h2>
            <p class="text-sm text-slate-500 mt-1">Create and manage e-services, translations, links, and pricing.</p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">
            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add E-Service</span>
        </button>
    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-6">
        <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
            [class.text-primary]="activeTab === lang.code"
            [class.border-primary]="activeTab === lang.code">
            <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200" />
            {{ lang.name }} ({{ getLanguageCount(lang.code) }})
        </button>
    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterServices(activeTab)"
            placeholder="Search e-services"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
        <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Category</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Title</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Language</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Price</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">Status</th>
                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right">Actions</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    <tr *ngFor="let obj of pagedServices" class="hover:bg-slate-50 transition-colors">
                        <td class="px-3.5 py-2.5 text-slate-600">{{ obj.categoryName }}</td>
                        <td class="px-3.5 py-2.5 text-slate-600">{{ obj.title }}</td>
                        <td class="px-3.5 py-2.5 text-slate-600">
                            <span class="px-2 py-1 rounded bg-slate-100 text-slate-600 text-xs">{{ obj.languageCode }}</span>
                        </td>
                        <td class="px-3.5 py-2.5 text-slate-600">
                            {{ (obj.priceFrom || 0) | number:'1.2-2' }} - {{ (obj.priceTo || 0) | number:'1.2-2' }}
                        </td>
                        <td class="px-3.5 py-2.5 text-slate-600">
                            <span class="px-2 py-1 rounded text-xs"
                                [ngClass]="obj.isEnabled ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-slate-600'">
                                {{ obj.isEnabled ? 'Active' : 'Inactive' }}
                            </span>
                        </td>
                        <td class="px-3.5 py-2.5 text-right">
                            <div class="flex justify-end gap-2">
                                <button class="p-1.5 text-slate-400 hover:text-primary" (click)="viewData(obj.serviceId, 'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>
                                <button class="p-1.5 text-slate-400 hover:text-red-500" (click)="viewData(obj.serviceId, 'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="6">
                            <div class="flex justify-center mt-6 mb-6 gap-2">
                                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                                    (click)="changePage(i + 1)"
                                    [ngClass]="currentPage === (i + 1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                                    class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                                    {{ i + 1 }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</main>

<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4 py-6">
    <div class="bg-white w-full max-w-[980px] max-h-[calc(100vh-64px)] overflow-hidden rounded-xl shadow-xl flex flex-col">
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">
            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">apps</span>
                    E-Service Details
                </h3>
                <p class="text-sm text-slate-500 mt-0.5">Create or update e-service metadata, links, and translations.</p>
            </div>
            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>
        </div>

        <div class="p-5 overflow-y-auto flex-1 min-h-0 space-y-6">
            <div class="space-y-6">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div class="space-y-4">
                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Category</label>
                            <select [(ngModel)]="categoryId" name="categoryId"
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option [ngValue]="null">Select category</option>
                                <option *ngFor="let category of categories" [ngValue]="category.categoryId">{{ category.name }}</option>
                            </select>
                        </div>

                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Icon</label>
                            <input type="text" [(ngModel)]="icon" name="icon" maxlength="100"
                                placeholder="Icon name or URL"
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>

                    <div class="space-y-4">
                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Status</label>
                            <select [(ngModel)]="isEnabled" name="isEnabled"
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option [ngValue]="true">Active</option>
                                <option [ngValue]="false">Inactive</option>
                            </select>
                        </div>

                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Front</label>
                            <select [(ngModel)]="isFronted" name="isFronted"
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option [ngValue]="false">Hidden</option>
                                <option [ngValue]="true">Shown</option>
                            </select>
                        </div>
                    </div>

                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label class="block mb-1 text-sm font-semibold text-gray-700">Price From</label>
                        <input type="number" [(ngModel)]="priceFrom" name="priceFrom" min="0"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>

                    <div>
                        <label class="block mb-1 text-sm font-semibold text-gray-700">Price To</label>
                        <input type="number" [(ngModel)]="priceTo" name="priceTo" min="0"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>

                    <div>
                        <label class="block mb-1 text-sm font-semibold text-gray-700">Days</label>
                        <input type="number" [(ngModel)]="durationDays" name="durationDays" min="0"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                </div>


                <div class="border-t border-gray-200 pt-5">
                    <div class="space-y-4">
                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Apply URL</label>
                            <input type="url" [(ngModel)]="applyUrl" name="applyUrl" maxlength="300"
                                placeholder="https://..."
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>

                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Download URL</label>
                            <input type="url" [(ngModel)]="downloadUrl" name="downloadUrl" maxlength="300"
                                placeholder="https://..."
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>

                        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <label class="sm:w-[150px] text-sm font-semibold text-gray-700">Requirement URL</label>
                            <input type="url" [(ngModel)]="requirementUrl" name="requirementUrl" maxlength="300"
                                placeholder="https://..."
                                class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex border-b border-gray-200 gap-6 mt-6">
                <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
                    class="pb-3 px-6 text-sm font-semibold border-b-2 flex items-center gap-2 transition-all"
                    [class.text-primary]="activeTabPopup === lang.languageId"
                    [class.border-primary]="activeTabPopup === lang.languageId">
                    <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-gray-200" />
                    {{ lang.name }}
                </button>
            </div>

            <form class="space-y-4 mt-4">
                <div *ngIf="activeTabPopup === 1">
                    <label class="block mb-1 text-sm font-semibold text-gray-700">Title (Khmer)</label>
                    <input type="text" [(ngModel)]="titleKh" name="titleKh" maxlength="150"
                        placeholder="Enter Khmer title"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Subtitle (Khmer)</label>
                    <input type="text" [(ngModel)]="subtitleKh" name="subtitleKh" maxlength="200"
                        placeholder="Enter Khmer subtitle"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Link Text (Khmer)</label>
                    <input type="text" [(ngModel)]="linkTextKh" name="linkTextKh" maxlength="100"
                        placeholder="Enter Khmer link text"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Description (Khmer)</label>
                    <textarea [(ngModel)]="descriptionKh" name="descriptionKh" rows="4"
                        placeholder="Enter Khmer description"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
                </div>

                <div *ngIf="activeTabPopup === 2">
                    <label class="block mb-1 text-sm font-semibold text-gray-700">Title (English)</label>
                    <input type="text" [(ngModel)]="titleEn" name="titleEn" maxlength="150"
                        placeholder="Enter English title"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Subtitle (English)</label>
                    <input type="text" [(ngModel)]="subtitleEn" name="subtitleEn" maxlength="200"
                        placeholder="Enter English subtitle"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Link Text (English)</label>
                    <input type="text" [(ngModel)]="linkTextEn" name="linkTextEn" maxlength="100"
                        placeholder="Enter English link text"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />

                    <label class="block mt-4 mb-1 text-sm font-semibold text-gray-700">Description (English)</label>
                    <textarea [(ngModel)]="descriptionEn" name="descriptionEn" rows="4"
                        placeholder="Enter English description"
                        class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"></textarea>
                </div>
            </form>
        </div>

        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">
            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>
            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>
            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>
        </div>
    </div>
</div>
